/* This is generated code, don't alter */
var IfcFanTypeEnum;
(function (IfcFanTypeEnum) {
    IfcFanTypeEnum[IfcFanTypeEnum["CENTRIFUGALFORWARDCURVED"] = 0] = "CENTRIFUGALFORWARDCURVED";
    IfcFanTypeEnum[IfcFanTypeEnum["CENTRIFUGALRADIAL"] = 1] = "CENTRIFUGALRADIAL";
    IfcFanTypeEnum[IfcFanTypeEnum["CENTRIFUGALBACKWARDINCLINEDCURVED"] = 2] = "CENTRIFUGALBACKWARDINCLINEDCURVED";
    IfcFanTypeEnum[IfcFanTypeEnum["CENTRIFUGALAIRFOIL"] = 3] = "CENTRIFUGALAIRFOIL";
    IfcFanTypeEnum[IfcFanTypeEnum["TUBEAXIAL"] = 4] = "TUBEAXIAL";
    IfcFanTypeEnum[IfcFanTypeEnum["VANEAXIAL"] = 5] = "VANEAXIAL";
    IfcFanTypeEnum[IfcFanTypeEnum["PROPELLORAXIAL"] = 6] = "PROPELLORAXIAL";
    IfcFanTypeEnum[IfcFanTypeEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcFanTypeEnum[IfcFanTypeEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcFanTypeEnum || (IfcFanTypeEnum = {}));
const IfcFanTypeEnumCount = 9;
export { IfcFanTypeEnum, IfcFanTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcFanTypeEnum = new Int32Array([13, 1, 12]);
let prefixSumAddressIfcFanTypeEnum = new Uint32Array([0, 35, 46, 62, 75, 86, 98, 118, 144, 163]);
let slotMapIfcFanTypeEnum = new Int32Array([2, 4, 6, 7, 5, 8, 3, 0, 1]);
let encodedDataIfcFanTypeEnum = (new TextEncoder()).encode(".CENTRIFUGALBACKWARDINCLINEDCURVED..TUBEAXIAL..PROPELLORAXIAL..USERDEFINED..VANEAXIAL..NOTDEFINED..CENTRIFUGALAIRFOIL..CENTRIFUGALFORWARDCURVED..CENTRIFUGALRADIAL.");
let IfcFanTypeEnumSearch = new MinimalPerfectHash(gMapIfcFanTypeEnum, prefixSumAddressIfcFanTypeEnum, slotMapIfcFanTypeEnum, encodedDataIfcFanTypeEnum);
export { IfcFanTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcFanTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcFanTypeEnumSearch, input, cursor, endCursor);
}
